import React from "react";
import { CogIcon, UserCircleIcon, SupportIcon, LockClosedIcon, UsersIcon, DesktopComputerIcon } from "@heroicons/react/outline"; // Heroicons
import { InView } from 'react-intersection-observer'; // Intersection Observer for animations

const WhyUs = () => {
  const features = [
    {
      icon: <CogIcon className="w-8 h-8 text-purple-700" />,
      title: "Fully Customizable",
      description: "Create custom designs for posters and business cards with complete flexibility to suit your needs.",
      bgColor: "bg-purple-500",
    },
    {
      icon: <UserCircleIcon className="w-8 h-8 text-blue-700" />,
      title: "Easy to Use",
      description: "No technical skills required! Start designing with our intuitive drag-and-drop interface.",
      bgColor: "bg-blue-500",
    },
    {
      icon: <SupportIcon className="w-8 h-8 text-green-700" />,
      title: "24/7 Support",
      description: "Need help? Our support team is available round-the-clock to assist with any issues you may face.",
      bgColor: "bg-green-500",
    },
    {
      icon: <LockClosedIcon className="w-8 h-8 text-red-700" />,
      title: "Data Security",
      description: "We ensure that your designs and personal data are stored securely with the highest levels of encryption.",
      bgColor: "bg-red-500",
    },
    {
      icon: <UsersIcon className="w-8 h-8 text-yellow-700" />,
      title: "Collaborative Features",
      description: "Share your designs easily with colleagues or clients for feedback, and collaborate on the go.",
      bgColor: "bg-yellow-500",
    },
    {
      icon: <DesktopComputerIcon className="w-8 h-8 text-teal-700" />,
      title: "Multi-Platform Access",
      description: "Access and create your designs from any device, whether it's a desktop, tablet, or mobile.",
      bgColor: "bg-teal-500",
    },
  ];

  return (
    <div className="py-8">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl font-semibold text-gray-800 mb-4">Why Choose EDIT EZY?</h2>
        <p className="text-base text-gray-600 mb-8">
          EDIT EZY makes it easy to create professional-quality posters and business cards. With user-friendly tools and customizable templates, anyone can create stunning designs effortlessly.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-6 gap-8">
          {features.map((feature, index) => (
            <InView
              key={index}
              triggerOnce={true}
              threshold={0.5}
            >
              {({ inView, ref }) => (
                <div
                  ref={ref}
                  className={`rounded-lg p-6 flex flex-col items-center text-center transform transition-transform hover:-translate-y-2 shadow-lg ${feature.bgColor} ${inView ? 'animate__animated animate__fadeIn' : ''}`}
                  style={{ minHeight: "220px", maxWidth: "400px", transition: "all 0.3s ease" }} // Adjusted width for small screens
                >
                  <div className="flex items-center justify-center w-16 h-16 rounded-full bg-white mb-4 shadow-md">
                    {feature.icon}
                  </div>
                  <h3 className="text-lg font-semibold text-white">{feature.title}</h3>
                  <p className="text-white mt-2 text-sm">{feature.description}</p>
                </div>
              )}
            </InView>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyUs;
